module.exports = __webpack_public_path__ + "assets/pin_restaurant-48a485.svg";